'use client'

import { Button } from '@qr-front/ui/components/Button'
import { useAtomValue } from 'jotai'
import Link from 'next/link'

import { HeaderContainer } from '@/components/HeaderContainer'
import { LogoLink } from '@/components/LogoLink/LogoLink'
import { ROUTES } from '@/constants'
import { userAtom } from '@/global-state'

import { TQrContent } from '../../generatorTypes'
import { useFrameFontSize } from '../../services/client'
import type { TQrDesign } from '../../services/types'
import { DownloadButtonWithModal } from './DownloadButtonWithModal'
import { QrImageWrapper } from './QrImageWrapper'

interface QrDownloadClientProps {
	uri: string
	content: TQrContent
	qrDesign: TQrDesign
	downloadText: string
	manageText: string
}

const ManageButton = ({ manageText }: { manageText: string }) => {
	const fontSize = useFrameFontSize({
		text: manageText,
		maxWidth: 220,
		maxSize: 18,
		fontFamily: 'var(--font-body)',
	})

	const style = {
		fontSize: `${fontSize}px`,
	}

	return (
		<Button asChild visual="secondary" size="large" className="w-full">
			<Link href={ROUTES.cabinet.qrCodes} style={style}>
				{manageText}
			</Link>
		</Button>
	)
}

export const QrDownloadClient = ({
	uri,
	content,
	qrDesign,
	downloadText,
	manageText,
}: QrDownloadClientProps) => {
	const user = useAtomValue(userAtom)

	return (
		<main className="min-h-dvh w-full bg-generator-bg desktop:h-dvh desktop:overflow-y-auto">
			<HeaderContainer className="bg-generator-bg">
				<div className="mx-auto gap-8 desktop:grid desktop:max-w-[min(1216px,calc(100%-64px))] desktop:grid-cols-12">
					<div className="col-span-full col-start-1 flex items-center justify-between desktop:col-span-9">
						<LogoLink />
					</div>
				</div>
			</HeaderContainer>
			<div
				className="mx-auto flex w-full max-w-[350px] flex-col items-center gap-4 desktop:max-w-[280px]"
				style={{
					paddingTop:
						'min(200px, max(65px, calc((100dvh - 610px) / 2)))',
				}}
			>
				<QrImageWrapper
					qrUri={uri}
					qrContent={content}
					qrDesign={qrDesign}
				/>
				<DownloadButtonWithModal
					uri={uri}
					downloadText={downloadText}
				/>
				{user && <ManageButton manageText={manageText} />}
			</div>
		</main>
	)
}
